export default __webpack_public_path__ + "src/images/btn_right_pink-28ff24.png";